import { Card } from "@/components/ui/card";

const EMPTY_IMAGES = {
  properties:
    "https://images.unsplash.com/photo-1678818467672-c55a054b3e8f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHw0fHxicm93bnN0b25lJTIwZmFjYWRlfGVufDB8fHx8MTc4MTA2NDMxOHww&ixlib=rb-4.1.0&q=85",
  tenants:
    "https://images.unsplash.com/photo-1763026481968-9c6240527c37?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBhcmNoaXRlY3R1cmUlMjBkZXRhaWx8ZW58MHx8fHwxNzgxMDY0MzA5fDA&ixlib=rb-4.1.0&q=85",
  maintenance:
    "https://images.unsplash.com/photo-1550336163-fd7bb464e5a2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwxfHxicmFzcyUyMGRldGFpbHN8ZW58MHx8fHwxNzgxMDY0MzE4fDA&ixlib=rb-4.1.0&q=85",
  documents: "https://images.pexels.com/photos/8092365/pexels-photo-8092365.jpeg",
  notes:
    "https://images.unsplash.com/photo-1526566762798-8fac9c07aa98?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwyfHxlbGVnYW50JTIwZGVzayUyMGFlc3RoZXRpY3N8ZW58MHx8fHwxNzgxMDY0MzA5fDA&ixlib=rb-4.1.0&q=85",
  incidents:
    "https://images.unsplash.com/photo-1552084850-c6a1fc7cf717?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBhcmNoaXRlY3R1cmUlMjBkZXRhaWx8ZW58MHx8fHwxNzgxMDY0MzA5fDA&ixlib=rb-4.1.0&q=85",
};

/**
 * Editorial empty-state card.
 * props:
 *  - kind: key into EMPTY_IMAGES ("properties" | "tenants" | "maintenance" | "documents" | "notes" | "incidents")
 *  - eyebrow: micro-label text (default "An empty page")
 *  - title: serif heading
 *  - body: muted body copy
 *  - action: optional ReactNode (e.g. <Button …>)
 */
export default function EmptyState({ kind = "properties", eyebrow = "An empty page", title, body, action, testid = "empty-state" }) {
  const img = EMPTY_IMAGES[kind] || EMPTY_IMAGES.properties;
  return (
    <Card className="rounded-none border border-bone bg-white p-0 overflow-hidden grid grid-cols-1 md:grid-cols-[1.1fr_1fr]" data-testid={testid}>
      <div className="p-10 md:p-12 flex flex-col justify-center">
        <div className="micro-label text-gold mb-3">{eyebrow}</div>
        <h3 className="font-display text-3xl tracking-tight text-ink leading-tight">{title}</h3>
        {body && <p className="text-sm text-slate-500 mt-3 leading-relaxed max-w-sm">{body}</p>}
        <div className="mt-6 flex items-center gap-3">
          <span className="h-px w-10 bg-gold" />
          {action}
        </div>
      </div>
      <div className="relative min-h-[200px] md:min-h-[260px] bg-bone">
        <img src={img} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-l from-transparent to-white/15" />
      </div>
    </Card>
  );
}
